export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conversations Intercom"])},
        "empty_state": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune conversation Intercom"])},
        "load_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Charger plus"])},
        "view_in_intercom": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir dans Intercom"])},
        "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impossible de charger les conversations"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Intercom Conversations"])},
        "empty_state": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No Intercom conversations"])},
        "load_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Load more"])},
        "view_in_intercom": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View in Intercom"])},
        "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unable to load conversations"])}
      }
    }
  })
}
